<div class="pl-pane__container--horizontal pl-pane--full-screen">
  <app-nav-bar [route]="backRoute"></app-nav-bar>

  @if (orgSiteDomain) {
    <app-ngin-iframe
      [path]="surveyResultUrl"
      [domain]="orgSiteDomain">
    </app-ngin-iframe>
  }
</div>
